module.exports = __webpack_public_path__ + "img/iPhone-background.daf49cfe.png";